var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAgent = function SvgAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.414 8.456v-.06a8.396 8.396 0 0 0-16.792 0v.06a2.999 2.999 0 0 0-2.399 2.938v2.4a2.999 2.999 0 0 0 2.999 2.998h1.2a1.799 1.799 0 0 0 1.798-1.8v-4.797a1.8 1.8 0 0 0-1.799-1.8h-.6a7.196 7.196 0 1 1 14.393 0h-.6a1.8 1.8 0 0 0-1.798 1.8v4.797a1.8 1.8 0 0 0 1.799 1.8h.863a6.345 6.345 0 0 1-4.905 4.641 1.787 1.787 0 0 0-1.62-1.031H10.46a1.8 1.8 0 0 0 0 3.598h2.495a1.799 1.799 0 0 0 1.75-1.38 7.52 7.52 0 0 0 5.998-5.996 2.998 2.998 0 0 0 2.075-2.843v-2.399a2.999 2.999 0 0 0-2.363-2.926ZM5.42 9.596a.6.6 0 0 1 .6.599v4.797a.6.6 0 0 1-.6.6h-1.2a1.799 1.799 0 0 1-1.798-1.799v-2.399a1.8 1.8 0 0 1 1.799-1.799h1.2Zm7.532 13.193H10.46a.6.6 0 0 1 0-1.2h2.495a.6.6 0 1 1 0 1.2Zm8.66-9.008a1.8 1.8 0 0 1-1.799 1.8h-1.2a.6.6 0 0 1-.599-.6v-4.798a.6.6 0 0 1 .6-.6h1.2a1.799 1.799 0 0 1 1.798 1.8v2.398Z",
    fill: "#5D79FF"
  })));
};

export default SvgAgent;